// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kLiE9":[function(require,module,exports) {
class InstitutionList {
    constructor(){
        this.handleSearchFilter();
        this.handleAlphabeticFilter();
        this.handleFilterSelect();
        this.handleSectorFilterSelect();
        this.handleRegionFilterSelect();
        this.handleRegionFilterSelectOption();
        this.handleCityFilterSelect();
        this.handlePaginationList();
        this.handleSinglePageButtons();
        this.handleClearFilters();
    }
    activeLoader() {
        const loader = document.querySelector("#person-register-loader");
        if (loader) loader.classList.remove("hidden");
        const fields = document.querySelectorAll("#person-list-filters input, #person-list-filters button, #person-list-filters select");
        fields.forEach((field)=>{
            field.setAttribute("disabled", "true");
        });
    }
    handleAlphabeticFilter() {
        const letters = document.querySelectorAll("#person-list-alphabetic-filter > button");
        letters.forEach((letter)=>{
            letter.addEventListener("click", ()=>{
                const letterData = letter.getAttribute("data-letter");
                if (letterData) {
                    const url = new URL(window.location.href);
                    url.searchParams.set("letter", letterData);
                    if (url.pathname.includes("/page/")) url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, "/");
                    this.activeLoader();
                    location.replace(url.toString());
                }
            });
        });
    }
    handleSearchFilter() {
        const form = document.querySelector("#person-list-search-form");
        const input = document.querySelector("#person-list-search-input");
        if (form) form.addEventListener("submit", (e)=>{
            e.preventDefault();
            const url = new URL(window.location.href);
            url.searchParams.delete("search");
            if (input.value) url.searchParams.set("search", input.value);
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleClearFilters() {
        const button = document.querySelector("#person-list-clear-filters");
        if (button) button.addEventListener("click", ()=>{
            const url = new URL(window.location.href);
            url.search = "";
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleFilterSelect() {
        const select = document.querySelector("#person-list-role-select");
        if (select) select.addEventListener("change", ()=>{
            const url = new URL(window.location.href);
            url.searchParams.delete("role");
            if (select.value) url.searchParams.set("role", select.value);
            if (url.pathname.includes("/page/")) {
                this.activeLoader();
                location.replace(url.pathname.replace(/\/page\/\d+\/?$/, "/"));
            }
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleCityFilterSelect() {
        const select = document.querySelector("#person-list-city-select");
        if (select) select.addEventListener("change", ()=>{
            const url = new URL(window.location.href);
            url.searchParams.delete("city");
            if (select.value) url.searchParams.set("city", select.value);
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleSinglePageButtons() {
        const buttons = document.querySelectorAll("button.person-single-button");
        buttons.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const url = button.getAttribute("data-url");
                if (url) {
                    this.activeLoader();
                    location.replace(url);
                }
            });
        });
    }
    handleRegionFilterSelectOption() {
        const regionSelect = document.querySelector("#person-list-region-select");
        if (regionSelect) {
            const selectedOption = regionSelect.options[regionSelect.selectedIndex];
            if (selectedOption) this.setSectorOptions(selectedOption);
        }
    }
    setSectorOptions(selectedOption) {
        if (!selectedOption.getAttribute("data-item")) return;
        const data = JSON.parse(selectedOption.getAttribute("data-item"));
        const sectorsSelect = document.querySelector("#person-list-sector-select");
        if (!sectorsSelect) return;
        const currentSector = sectorsSelect.getAttribute("data-sector");
        const sectorLabel = sectorsSelect.getAttribute("data-sector-label") || "Setor";
        if (data.sectors) sectorsSelect.innerHTML = `<option value="">Selecione um ${sectorLabel}</option>`;
        data.sectors.forEach((sector)=>{
            const option = document.createElement("option");
            option.value = sector.id;
            option.innerText = sector.name;
            if (currentSector == sector.id) option.selected = true;
            sectorsSelect.appendChild(option);
        });
    }
    handleSectorFilterSelect() {
        const select = document.querySelector("#person-list-sector-select");
        if (select) select.addEventListener("change", ()=>{
            const url = new URL(window.location.href);
            url.searchParams.delete("setor");
            if (select.value) url.searchParams.set("setor", select.value);
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handleRegionFilterSelect() {
        const select = document.querySelector("#person-list-region-select");
        if (select) select.addEventListener("change", ()=>{
            const url = new URL(window.location.href);
            url.searchParams.delete("region");
            url.searchParams.delete("sector");
            if (select.value) url.searchParams.set("region", select.value);
            this.activeLoader();
            location.replace(url.toString());
        });
    }
    handlePaginationList() {
        const paginationItems = document.querySelectorAll(".pagination-item");
        paginationItems.forEach((item)=>{
            const page = item.getAttribute("data-page");
            if (page) {
                const url = new URL(window.location.href);
                item.href = `${item.href}page/${page}/?${url.searchParams.toString()}`;
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    new InstitutionList();
});

},{}]},["kLiE9"], "kLiE9", "parcelRequire734e")

//# sourceMappingURL=person-list.js.map
